import React, { Component } from "react";

import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import { Link } from "react-router-dom";

import { Route, Router } from "react-router-dom";
// Be sure to include styles at some point, probably during your bootstraping
import "@trendmicro/react-sidenav/dist/react-sidenav.css";

class SideNavs extends Component {
  state = {};
  render() {
    return (
      <SideNav
        disabled={false}
        className="side-nav-height"
        onSelect={(selected) => {
            const to = '/' + selected;
           // if (location.pathname !== to) {
                // history.push(to);
                window.location = to
            //}
        }}
      >
        <SideNav.Toggle />
        <SideNav.Nav>
          <NavItem eventKey="#/dashboard/locations">
            <NavIcon>
                <i
                  className="fa fa-fw fa-home"
                  style={{ fontSize: "1.75em" }}
                />
            </NavIcon>

            <NavText>
              Locations
            </NavText>
          </NavItem>
          <NavItem eventKey="#/dashboard/categories">
            <NavIcon>
              
                <i
                  className="fa fa-caret-square-o-left"
                  style={{ fontSize: "1.75em" }}
                />
              
            </NavIcon>
            <NavText>
              Categories
            </NavText>
          </NavItem>

          <NavItem eventKey="#/dashboard/items">
            <NavIcon>
              
                <i className="fa fa-inbox" style={{ fontSize: "1.75em" }} />
              
            </NavIcon>
            <NavText>
              Items
            </NavText>
          </NavItem>
          <NavItem eventKey="#/dashboard/ingredients">
            <NavIcon>
              
                <i className="fa fa-industry" style={{ fontSize: "1.75em" }} />
              
            </NavIcon>
            <NavText>
              Ingredients
            </NavText>
          </NavItem>
          <NavItem eventKey="#/dashboard/extras">
            <NavIcon>
              
                <i
                  className="fa fa-plus-square-o"
                  style={{ fontSize: "1.75em" }}
                />
              
            </NavIcon>
            <NavText>
              Extras
            </NavText>
          </NavItem>
          <NavItem eventKey="#/dashboard/banners">
            <NavIcon>
              
                <i className="fa fa-bandcamp" style={{ fontSize: "1.75em" }} />
              
            </NavIcon>
            <NavText>
              Banners
            </NavText>
          </NavItem>
          <NavItem eventKey="#/dashboard/waittime">
            <NavIcon>
              
                <i className="fa fa-clock-o" style={{ fontSize: "1.75em" }} />
              
            </NavIcon>
            <NavText>
              Waiting Time
            </NavText>
          </NavItem>
          <NavItem eventKey="#/dashboard/businesshours">
            <NavIcon>
              
                <i
                  className="fa fa-hourglass-start"
                  style={{ fontSize: "1.75em" }}
                />
              
            </NavIcon>
            <NavText>
              Business Hours
            </NavText>
          </NavItem>

          <NavItem eventKey="#/dashboard/tips">
            <NavIcon>
              
                <i
                  className="fa fa-superpowers"
                  style={{ fontSize: "1.75em" }}
                />
              
            </NavIcon>
            <NavText>
              Tips
            </NavText>
          </NavItem>
          <NavItem eventKey="devices">
            <NavIcon>
              
                <i
                  className="fa fa-superpowers"
                  style={{ fontSize: "1.75em" }}
                />
              
            </NavIcon>
            <NavText>
              Specialdeal
            </NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
    );
  }
}

export default SideNavs;
